<template>
  <panel-browser
    title="Event and Type Documentation"
    :search.sync="search">
    <a
      v-for="item in displayList"
      :key="item.type"
      class="panel-block level"
      :class="{'is-active': item.label === selected }"
      @click="selectDef(item.label)">
      <span class="level-left">
        <svgicon
          v-if="item.icon"
          class="level-item"
          :name="item.icon"
          height="25"
          width="25"
          :original="true">
        </svgicon>
        <svgicon
          v-else
          class="level-item"
          name="objects"
          height="25"
          width="25"
          :original="true">
        </svgicon>
        <span class="level-item">{{ item.label }}</span>
      </span>
    </a>
    <template slot="filter-tabs">
      <a @click="filter = null" :class="{'is-active-filter': filter === null }">All</a>
      <a @click="filter = 'events'" :class="{'is-active-filter': filter === 'events' }">Events</a>
      <a @click="filter = 'types'" :class="{'is-active-filter': filter === 'types' }">Types</a>
    </template>
    <event-definition-details slot="right" :def="currentDef"></event-definition-details>
  </panel-browser>
</template>

<script>
import _ from 'lodash';
import { mapMutations } from 'vuex';
import PanelBrowser from '@/components/PanelBrowser.vue';
import EventDefinitionDetails from '@/components/documentation/EventDefinitionDetails.vue';

export default {
  name: 'DocumentationSection',
  components: { EventDefinitionDetails, PanelBrowser },
  data() {
    return {
      filter: null,
      search: '',
      currentDef: this.$typeDefs.events.GPFSEvent,
      selected: 'null',
    };
  },
  computed: {
    filteredList() {
      if (this.filter === null) {
        return this.eventsList.concat(this.typesList);
      }
      if (this.filter === 'events') {
        return this.eventsList;
      }
      return this.typesList;
    },
    displayList() {
      if (this.search.length >= 0) {
        return this.filteredList
          .filter(item => item.label.toLowerCase().startsWith(this.search));
      }
      return this.filteredList;
    },
    eventsList() {
      return Object.values(this.$typeDefs.events);
    },
    typesList() {
      return Object.values(this.$typeDefs.types);
    },
  },
  mounted() {
    this.SET_SECTION('Documentation');
  },
  methods: {
    ...mapMutations(['SET_SECTION']),
    selectDef(labelValue) {
      this.selected = labelValue;
      const index = _.findIndex(this.displayList, { label: labelValue });
      this.currentDef = this.displayList[index];
    },
  },
};
</script>

<style lang="scss" scoped>
a.is-active-filter {
  color: $font-color;
}

a.level {
  margin-bottom: 0;
  color: whitesmoke;
}

a.is-active, a:hover {
  background: $form-subitem;
  color: whitesmoke;
  border-bottom-color: $border-color;
}

a.panel-block:hover {
  background: $form-subitem;
}

</style>
